import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import './style.scss'

export default class Button extends Component {
    static propTypes = {
        disabled: PropTypes.bool,
        onClick: PropTypes.func,
        text: PropTypes.string,
        type: PropTypes.string,
    }

    static defaultProps = {
        disabled: false,
        onClick: () => {},
        text: '',
        type: 'submit',
    }

    onClickHandler = () => {
        const { disabled, onClick } = this.props

        if (!disabled) onClick()
    }

    render() {
        const { text, disabled, type } = this.props

        return (
            <button
                className={cx('form-button', disabled && 'disabled')}
                type={type}
                disabled={disabled}
                onClick={this.onClickHandler}
            >
                {text}
            </button>
        )
    }
}
